// Faut-il avertir l'utilisateur que ses totaux sont incomplets ?
//
// MODULE PUR : aucun import `wasp/*` ni React, donc testable isolément. La
// règle vit ici plutôt que dans le hook `useRealtimeSync` parce qu'un hook
// exigerait React Testing Library, absent du projet — et que cette décision
// mérite des tests : c'est elle qui décide d'afficher ou non un avertissement
// sur des chiffres financiers.

/** Forme minimale lue sur une connexion renvoyée par `getTradovateConnections`. */
interface ConnectionLike {
  syncProgress?: { state: string; totalsArePartial: boolean };
}

/**
 * Au moins une connexion rend-elle les totaux affichés incomplets ?
 *
 * UNE SEULE SUFFIT, et c'est le point important : le calendrier et les
 * agrégats du dashboard additionnent les trades de TOUTES les connexions sans
 * distinction. Un seul import en cours, ou un seul cycle bridé par le quota,
 * rend donc le total du jour faux — pas seulement la part de cette connexion.
 *
 * Une connexion sans `syncProgress` (serveur antérieur au champ) est ignorée :
 * on préfère n'afficher aucun avertissement plutôt qu'un bandeau permanent
 * fondé sur une supposition, qui deviendrait lui-même un motif de ticket.
 */
export function anyTotalsArePartial(
  connections: readonly (ConnectionLike | null | undefined)[] | undefined,
): boolean {
  return (connections ?? []).some(
    (conn) => conn?.syncProgress?.totalsArePartial === true,
  );
}
